module.exports = __webpack_public_path__ + "static/media/back8.ceebead7.jpg";